import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid2 } from "@mui/material";
import useStyles from "./effective-work-days-table.style";

type EffectiveWorkDayItem = {
  date: string | Date;
  workDays: number;
  effectiveWorkDay?: number;
};

interface MyLeaveEffectiveWorkDaysTableProps {
  effectiveWorkDaysByDays: EffectiveWorkDayItem[];
}

export const MyLeaveEffectiveWorkDaysTable: React.FC<
  MyLeaveEffectiveWorkDaysTableProps
> = ({ effectiveWorkDaysByDays }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  let counter = 0;

  return (
    <Box className={classes.container}>
      <Grid2 container spacing={0}>
        <Box className={classes.tableHeader}>
          <Grid2 size={{ xs: 2 }}>
            <Box>{t("MY_LEAVE_DAYS")}</Box>
          </Grid2>
          <Grid2 size={{ xs: 3 }}>
            <Box>{t("OC_DATE")}</Box>
          </Grid2>
          <Grid2 size={{ xs: 4 }}>
            <Box>{t("MY_LEAVE_CONTRACT_WORKDAYS")}</Box>
          </Grid2>
          <Grid2 size={{ xs: 3 }}>
            <Box>{t("MY_LEAVE_EFFECTIVE_WORKDAYS")}</Box>
          </Grid2>
        </Box>
        {effectiveWorkDaysByDays?.map((item, index) => {
          if (item?.workDays === 0) return null;
          counter += 1;
          return (
            <React.Fragment key={index}>
              <Box className={classes.tableItem}>
                <Grid2 size={{ xs: 2 }}>
                  <Box>{`${counter}. ` + t("OC_DAY")}</Box>
                </Grid2>
                <Grid2 size={{ xs: 3 }}>
                  <Box>{new Date(item?.date).toLocaleDateString()}</Box>
                </Grid2>
                <Grid2 size={{ xs: 4 }}>
                  <Box>{item?.workDays}</Box>
                </Grid2>
                <Grid2 size={{ xs: 3 }}>
                  <Box>{item?.effectiveWorkDay?.toLocaleString()}</Box>
                </Grid2>
              </Box>
            </React.Fragment>
          );
        })}
      </Grid2>
    </Box>
  );
};

export default MyLeaveEffectiveWorkDaysTable;
